import ExpressRatePage from '../containers/Rate/Express/ExpressRate'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers'
 
const Express = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <ExpressRatePage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Express
